import humanizeBytes from '@mc/fn/humanizeBytes';

export const getReadableFileSize = (filesize: number): string => {
  const readableFileSzie = humanizeBytes(filesize) || '';
  const main = readableFileSzie.slice(0, -2);
  const lastTwo = readableFileSzie.slice(-2).toUpperCase();
  return `${main} ${lastTwo}`;
};
